const translations = {
    noItems: 'No Items',
    noMoreItems: 'No More Items'
};

export default translations;
